export enum Flows {
    Flujo1_1 = 1,
    Flujo2_1 = 2,
    Flujo2_2 = 3,
    Flujo3_1 = 4,
    Flujo3_2 = 5,
    Flujo4_1 = 6,
    Flujo4_2 = 7,
    Flujo5_1 = 8,
    ActualizacionAccionistasRepresentantesDocumentosBSP = 9,
    ActualizacionAccionistasRepresentantesDocumentosOtros = 10,
    ActualizacionAccionistasRepresentantesSinDocumentacionBSP = 11,
    ActualizacionAccionistasRepresentantesSinDocumentacionOtros = 12,
    NuevoIATAEXT = 13,
    NuevoIATACOLTC = 14,
    NuevoIATACOLContrato = 15,
    ActualizacionPaisCiudad = 16,
    Flujo6_1 = 17,
    Flujo6_2 = 18,
    Primeringreso = 19,
    CambioRepresentanteAdministrador = 20
}